/* eslint-disable max-len */
import isWithinRange from 'date-fns/is_within_range';

import { TabEnum } from '../store/ProductDetails/constants';

// склонения слов
export const declOfNum = (number, words) =>
  words[
    number % 100 > 4 && number % 100 < 20 ?
      2
    : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
  ];

export const isCurrentDateWithinInterval = (timeFrom, timeTo, curDate = new Date()) => {
  if (!timeFrom || !timeTo) {
    return true;
  }
  return isWithinRange(curDate.getTime(), new Date(timeFrom).getTime(), new Date(timeTo).getTime());
};

export const isHashInUrl = () => !!(window && window.location.hash);

export const getCurrentSection = (isFeedback, isHash, sectionFromHash) => {
  if (isHash) {
    return sectionFromHash;
  }

  if (isFeedback) {
    return TabEnum.CONTENT_TAB_FEEDBACK;
  }

  return TabEnum.CONTENT_TAB_ABOUT;
};

export const setHashToUrl = (data) => {
  window.location.hash = data;
};

export const getHashDataFromUrl = () => {
  const { hash } = window.location;

  if (!hash) {
    return '';
  }

  return hash.replace('#', '');
};

export const noop = () => {};

export const getDomainFromUrl = (url) => {
  if (typeof url !== 'string') return '';

  const result = url.split('/');
  return result[2];
};

export const getOriginFromUrl = (url) => {
  if (typeof url !== 'string') return '';

  const result = url.split('/');
  return `${result[0]}//${result[2]}`;
};
